(function(){
  var R=document.documentElement;
  function onScroll(){if(window.scrollY>40){R.classList.add('cx-scrolled');}else{R.classList.remove('cx-scrolled');}}
  onScroll();
  window.addEventListener('scroll',onScroll,{passive:true});

  var reduce=false;
  try{reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(e){}
  if(!reduce){R.classList.add('cx-motion-ready');}

  if(!reduce){
    var imgs=document.querySelectorAll('.card__media img, .product__media img, .media img, .featured-item-image img, .bubble-img img, .cf .shot img');
    imgs.forEach(function(im){
      im.classList.add('cx-img');
      if(im.complete&&im.naturalWidth>0){im.classList.add('cx-imgin');}
      else{
        im.addEventListener('load',function(){im.classList.add('cx-imgin');});
        im.addEventListener('error',function(){im.classList.add('cx-imgin');});
      }
    });
    setTimeout(function(){document.querySelectorAll('.cx-img:not(.cx-imgin)').forEach(function(im){im.classList.add('cx-imgin');});},2000);
  }

  if(reduce||!('IntersectionObserver' in window)){
    var immediateProof=document.querySelector('.chh .proof');
    if(immediateProof){immediateProof.classList.add('cx-proof-in');}
    return;
  }

  var vh=window.innerHeight||800;
  var fold=vh*.85;
  var sectionObserver=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){entry.target.classList.add('cx-in');sectionObserver.unobserve(entry.target);}
    });
  },{rootMargin:'0px 0px 12% 0px',threshold:.01});
  document.querySelectorAll('.shopify-section').forEach(function(section){
    if(section.getBoundingClientRect().top>fold){section.classList.add('cx-reveal');sectionObserver.observe(section);}
  });

  var motionObserver=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){entry.target.classList.add('cx-motion-in');motionObserver.unobserve(entry.target);}
    });
  },{rootMargin:'0px 0px -4% 0px',threshold:.08});
  document.querySelectorAll('body.page-index .bubble-check, body.page-index .wheel-surface, body.page-index .cf').forEach(function(section){
    section.classList.add('cx-motion-section');
    motionObserver.observe(section);
  });

  var proof=document.querySelector('.chh .proof');
  if(proof){
    var proofObserver=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){proof.classList.add('cx-proof-in');proofObserver.disconnect();}
      });
    },{threshold:.2});
    proofObserver.observe(proof);
  }
})();
